import React, { useMemo } from 'react'
import { useTranslation } from 'react-i18next'
import { Typography } from '@mui/material'
import { styled } from '@mui/material/styles'
import { Link, useLocation, matchPath } from 'react-router-dom'
import classNames from 'classnames'

import { ROLES_SIXT, useAuth } from '../../auth'

const classes = {
  linksContainer: 'links-container',
  link: 'link',
  active: 'active',
}
const LinksWrapper = styled('div')(({ theme }) => ({
  flexGrow: 1,
  [`& .${classes.linksContainer}`]: {
    display: 'flex',
    justifyContent: 'center',
    textAlign: 'center',
  },
  [`& .${classes.link}`]: {
    paddingLeft: theme.spacing(0.5),
    paddingRight: theme.spacing(0.5),
    marginLeft: theme.spacing(2),
    marginRight: theme.spacing(2),
    display: 'flex',
    alignItems: 'center',
  },
  [`& .${classes.active}`]: {
    '& > p': {
      color: theme.palette.primary.main,
      '&:visited': {
        color: theme.palette.primary.main,
      },
    },
  },
}))

const createLinks = (t) => {
  return [
    { to: '/agenda', label: t('menu.agendaPage'), requireRoles: [] },
    {
      to: '/sessions',
      label: t('menu.sessionsPage'),
      requireRoles: ROLES_SIXT,
    },
    { to: '/cars-to-buy', label: t('menu.carsToBuyPage') },
    { to: '/cars-booked', label: t('menu.carsBookedPage') },
    {
      to: '/assignment',
      label: t('menu.assignmentPage'),
      requireRoles: ROLES_SIXT,
    },
    { to: '/partner-inventory', label: t('menu.partnerInventoryPage') },
    {
      to: '/rules',
      label: t('menu.rulesPage'),
      requireRoles: ROLES_SIXT,
    },
    {
      to: '/users',
      label: t('menu.usersPage'),
      requireRoles: ROLES_SIXT,
    },
  ]
}
export default function MainToolbarLinks() {
  const { t } = useTranslation()
  const { hasOneOfRoles } = useAuth()

  const links = useMemo(() => createLinks(t), [t])
  const location = useLocation()

  return (
    <LinksWrapper>
      <div className={classes.linksContainer}>
        {links.map((link) => {
          const match = matchPath(
            {
              path: link.to,
              end: false,
            },
            location.pathname
          )
          return hasOneOfRoles(link.requireRoles) ? (
            <Link
              key={link.label}
              to={link.to}
              className={classNames(classes.link, {
                [classes.active]: match,
              })}
            >
              <Typography variant="body2" color="textPrimary">
                <strong> {link.label} </strong>
              </Typography>
            </Link>
          ) : (
            false
          )
        })}
      </div>
    </LinksWrapper>
  )
}
